import Slider from "react-slick";
import React from "react";

export default function InstalllationAssessment({ data }) {

  const settings2 = {
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3000,
    pauseOnHover: true,
       responsive: [
      { breakpoint: 1199, settings: { slidesToShow: 2 } },
      { breakpoint: 991, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],


  };

  return (
    <section className="assessment-sec">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-8">
            <div className="assessment-text">
              <h2 className="heading">What We Check Before A Single Machine Arrives</h2>
            </div>
          </div>
        </div>
        <div className="assessment-slide">
          <Slider {...settings2} className="assessment-slider">
            {data?.map((item, index) => (
              <div className="assessment-col" key={index}>
                <div className="assessment-inner">
                  <div className="content">
                    <h3 className="heading" dangerouslySetInnerHTML={{ __html: item?.title }}></h3>
                    <p>{item?.description}</p>
                  </div>
                  <div className="image-wrapper">
                    <img src={item?.image} alt="Machine" className="img-responsive" />
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
}